import React from "react";
import ComponenetHeader from "../common/ComponenetHeader";

const PrivacyPolicy = () => {

  return (<>

    {/*   <ComponenetHeader
      name={'Privacy Policy'}
    />  */}

    <section className="content_page text-left">
      <div className="container">
        <div className="row content_page_style justify-content-center">
          <div className="col-md-12">
            <h2 className="mb-4">Privacy Policy</h2>
            <h3>Introduction</h3>
            <p>
              At Towing 411, your privacy is important to us. We are committed to protecting your personal data and ensuring that any personally identifiable information ("Personal Information") you share with us is collected, used, and stored responsibly.
            </p>
            <p>
              This Privacy Policy explains how Towing 411 collects, uses, and safeguards your Personal Information when you access or use our platform.
            </p>

            <h3>Personal Information</h3>
            <p>
              Personal Information includes any data that can be used to identify an individual, such as names, mailing addresses, email addresses, phone numbers, or other information linked to a specific person.
            </p>
            <p>
              Towing 411 may update this Privacy Policy from time to time without prior notice. The most current version will always be available on our website. Your continued use of the platform signifies your acceptance of the updated policy.
            </p>

            <h3>Cookies</h3>
            <p>
              Cookies are small text files stored on your device by your web browser. They allow us to recognize returning users and improve their experience by personalizing content, features, and offers.
            </p>
            <p>
              Most browsers accept cookies automatically; however, you may choose to disable cookies through your browser settings. Please note that limiting cookies may affect certain functionalities of the website.
            </p>

            <h3>How We Use Your Information</h3>
            <p>
              We use the information we collect to:
            </p>
            <ul>
              <li>Create, maintain, and manage user accounts.</li>
              <li>Enable secure authentication and login processes.</li>
              <li>Process rewards related to bill uploads and other app features.</li>
              <li>Send service-related notifications, updates, and promotional messages.</li>
              <li>Improve platform functionality, performance, and user experience.</li>
              <li>Meet legal, regulatory, or compliance requirements.</li>
            </ul>

            <h4>Rewards and Bill Uploads</h4>
            <p>
              When users upload bills through the Towing 411 platform, the documents are securely stored solely for verification and reward processing purposes. Uploaded bills are not used for marketing and are not shared with third parties. Participation in the rewards program is optional.
            </p>

            <h4>We Do Not Sell Your Personal Information</h4>
            <p>
              Towing 411 does not sell, rent, or share Personal Information for marketing or advertising purposes.
            </p>
            <p>
              Information may be collected through:
            </p>
            <ul>
              <li>Use of our website, mobile site, or mobile application.</li>
              <li>Communications via email, SMS, or other electronic messaging services.</li>
              <li>Engagement with our social media channels, including Facebook, Twitter, LinkedIn, and YouTube.</li>
            </ul>
            <p>
              Third-party platforms operate under their own privacy policies, and Towing 411 is not responsible for their data handling practices.
            </p>

            <h4>Disclosure of Personal Information</h4>
            <p>
              Towing 411 may disclose Personal Information under the following circumstances:
            </p>
            <ul>
              <li>When information is submitted through co-branded or partner websites.</li>
              <li>To trusted service providers assisting with platform operations.</li>
              <li>In connection with a merger, acquisition, sale of assets, or business transfer.</li>
              <li>When required to comply with applicable laws, regulations, or legal processes.</li>
            </ul>
            <p>
              We do not sell or trade Personal Information. Business names of vendors or account holders may be displayed publicly, and vendor feedback may be shared with service providers only with prior consent.
            </p>

            <h4>Consent</h4>
            <p>
              By submitting your Personal Information, you consent to its collection, use, storage, and disclosure in accordance with this Privacy Policy.
            </p>
            <p>
              Significant updates to this policy may be communicated via email or website notifications. Users are encouraged to keep their contact details current and review this policy periodically.
            </p>

            <h4>Security Safeguards</h4>
            <p>
              Protecting your information is a shared responsibility. Users should safeguard their login credentials and avoid sharing sensitive information publicly.
            </p>
            <p>
              While Towing 411 implements reasonable technical and organizational security measures, no method of online data transmission is completely secure. Information shared online is done at the user’s own risk.
            </p>

            <h5>Additional Information</h5>
            <p>
              If you have any questions or concerns regarding this Privacy Policy, please contact us at <strong>contact@towing411.net</strong>.
            </p>

          </div>
        </div>
      </div>
    </section>

  </>
  );
};

export default PrivacyPolicy;